import SodEndPointChip from './SodEndPointChip';

export default SodEndPointChip;
